import _ from 'lodash';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { mapMyIndiaService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'PickupMap',
  // initialState: booksAdapter.getInitialState(),
  initialState: adapter.getInitialState({
    busy: true,
  }),

  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
  },
});

const FetchSellersAgainstCommodityReqOfferId = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await mapMyIndiaService.FetchSellersAgainstCommodityReqOfferId(params);
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  ...slice.actions,
  FetchSellersAgainstCommodityReqOfferId,
};

const selectors = {
  ...adapter.getSelectors((state) => state.PickupMap),
};

export { actions, selectors };

export default slice.reducer;
